import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient, } from '@angular/common/http';
import { Login } from 'src/app/shared/models/login';
import { CookieService } from 'ngx-cookie-service';
import { UsuarioService } from '../services/usuario/usuario.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient,private cookies: CookieService,private usuarioServices:UsuarioService) {

  }


  login(login: Login): Observable<any> {
  
    return this.http.post<any>(`${environment.urlBack}/loginLDAP`, login, { observe: 'events' }).pipe(tap(
      (res: any) => {
        return res;
      })
    );
  }


  Token(login:any): Observable<any> {
    login=environment.user;
    login.resource="API";
    return this.http.post<any>(`${environment.apiUrl}/api/login`, login).pipe(tap(
      (res: any) => {
        return res;
      })
    );
  }

  authenticate(): Observable<any> {
    let login = new Login(environment.userApi.username, environment.userApi.password);
    return this.http.post<any>(`${environment.urlBack}/authenticate`, login).pipe(tap(
      (res: any) => {
        return res;
      })
    );
  }
  logout() {
    this.cookies.deleteAll();
    localStorage.removeItem('filtroActividadesHome');
    localStorage.removeItem('filtroAsignadas');
    localStorage.removeItem('filtroNoAsignadas');
    localStorage.removeItem('user');
    localStorage.removeItem('ordenCampoPendientes');
    localStorage.removeItem('ordenTipoPendientes');
    localStorage.removeItem('ordenTipoProcesados');
    localStorage.removeItem('ordenCampoProcesados');
  }

}
